// src/utils/permission.js
import { getStore, setStore } from "@/utils/auth";
import { authInfo, userInfo } from "@/api/login";

// 权限类型枚举
export const PermissionType = {
  AUTH_SELLER: "isAuthSeller",
  AUTH_BUYER: "isAuthBuyer",
  AUTH_LOGISTICS: "isAuthLogistics",
  AUTH_REAL: "isAuth"
};

// 获取所有权限
export async function fetchAllPermissions() {
  try {
    const [userRes, authRes] = await Promise.all([userInfo(), authInfo()]);
    
    if (userRes.data) {
      setStore("userInfo", JSON.stringify(userRes.data));
      setStore("isAuth", JSON.stringify(userRes.data.isRealAuth));
    }
    
    if (authRes.data) {
      setStore("isAuthSeller", JSON.stringify(authRes.data.sellerAuthStatus));
      setStore("isAuthBuyer", JSON.stringify(authRes.data.buyerAuthStatus));
      setStore("isAuthLogistics", JSON.stringify(authRes.data.logisticsAuthStatus));
    }
  } catch (error) {
    console.error("获取权限失败:", error);
  }
}

// 判断单个权限
export function checkPermission(permissionType) {
  return getStore(permissionType) === "1";
}

// 批量检查权限
export function checkPermissions(permissionTypes) {
  return permissionTypes.every(type => checkPermission(type));
}

// 判断是否有权限（任一）
export function hasAnyPermission(permissionTypes) {
  return permissionTypes.some(type => checkPermission(type));
}